module.exports = __webpack_public_path__ + "img/stock1.23f34132.png";